import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LONG_RUNNING_PROCESS_LIST_HELP: HelpContent[] = [
    {
        helpContentId: 'long-running-process-list.update-error',
        tooltipText: 'Update to error status.  Use when a long-running process has terminated abnormally and the status was not updated to error.'
    }
];
